import { render } from "./classification.vue?vue&type=template&id=6c354dd6&scoped=true&ts=true"
import script from "./classification.vue?vue&type=script&lang=ts"
export * from "./classification.vue?vue&type=script&lang=ts"

import "./classification.vue?vue&type=style&index=0&id=6c354dd6&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c354dd6"]])

export default __exports__